import React, { useEffect, useRef } from 'react'
import styles from './CarouselVideo.module.scss'
import { useIsSmartphoneLandscape, useWindowSize } from 'utils/hooks'
import { isMobileOnly } from 'react-device-detect'

export interface CarouselVideoProps {
  autoPlay?: boolean
  backgroundVideo: {
    url: string
  }
  posterImage: {
    url: string
  }
  videoLoop: boolean
  isPaused?: boolean | null
  detailsCardHeight: number
}

const CarouselVideo = ({ autoPlay = true, backgroundVideo, posterImage, videoLoop, isPaused = null, detailsCardHeight }: CarouselVideoProps) => {
  const backgroundVideoRef = useRef<HTMLVideoElement>(null)
  const { isBreakpoint: isBelowBreakpointMd } = useWindowSize('md', '<')
  const isSmartphoneLandscape = useIsSmartphoneLandscape() || isMobileOnly

  const playVideo = () => {
    backgroundVideoRef.current
      ?.play()
      .then(() => {
        // @ts-ignore
        backgroundVideoRef.current.poster = ''
      })
      .catch(() => {
        console.log('Unable to play video')
      })
  }

  useEffect(() => {
    if (backgroundVideoRef && backgroundVideoRef.current) {
      if (isPaused === false) {
        playVideo()
      } else {
        backgroundVideoRef?.current?.pause()
      }
    }
  }, [isPaused, backgroundVideoRef])

  const getSupportedHeightUnit = () => (CSS.supports('height', '100dvh') ? '100dvh' : '100vh')

  return (
    <div
      className={styles['full-screen-video-container']}
      style={{
        height:
          isBelowBreakpointMd || isSmartphoneLandscape ? `calc(${getSupportedHeightUnit()} - ${Math.round(detailsCardHeight + 54 + 20)}px)` : '100vh'
      }}
    >
      <video autoPlay={autoPlay} loop={videoLoop} ref={backgroundVideoRef} muted playsInline={true} poster={posterImage?.url} disableRemotePlayback>
        <source src={backgroundVideo?.url} type="video/mp4" />
      </video>
    </div>
  )
}
export default CarouselVideo
